module.exports = __webpack_public_path__ + "img/empower.a86452d9.png";